import React from 'react';
import { Message } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import TextWithEllipsis from '../Extensions/TextWithEllipsis';
import './ResultRenderer.css';

function ResultRenderer(props) {
  const {
    results, handleResultSelect, isShowResult, isShowResultforVer, hanldeProjectScroll, translate, Ref
  } = props;
  const options = results.map((item) => {
    if (item.id !== 'exact') {
      return (
        <div className="result" key={item.id} onMouseDown={(e) => { return handleResultSelect(e, item); }}>
          <Message className="content"><TextWithEllipsis className="" text={item.name} as="span" /></Message>
        </div>
      );
    }
    return (
      <div className="result" key={item.id} onMouseDown={(e) => { return handleResultSelect(e, item); }}>
        <Message className="content" style={{ fontWeight: '700' }}>
          <TextWithEllipsis className="" text={`${item.name} (NEW)`} as="span" />
        </Message>
      </div>
    );
  });

  return (
    <div
      className={cx('results custom', {
        visible: isShowResult || isShowResultforVer,
      })}
      ref={Ref}
    >
      <Scrollbars
        renderTrackHorizontal={() => {
          return <div />;
        }}
        renderThumbHorizontal={() => {
          return <div />;
        }}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={180}
        onScroll={hanldeProjectScroll}
      >
        {options.length !== 0 ? (options) : (<Message className="empty"><Message.Header>{translate('knowledgebase.message.no_results_found')}</Message.Header></Message>)}
      </Scrollbars>
    </div>
  );
}

export default ResultRenderer;
